export default __webpack_public_path__ + "static/media/logoText.b9606c36.png";